import React, {useReducer, useEffect, useContext} from "react";
import {objectReplaceReducer} from '../lib/Utils';
import {Divider, Menu, Pagination, Typography} from "antd";
import "./Helpers.css";
import {ClientBridge} from "../index";
import {AodIcon} from "../AodUi/AodIcon";


export function MeasureImg({src, onMeasure}){

    const [state, dispatch] = useReducer(objectReplaceReducer, {width:0,height:0});

    const onImgLoad = ({target:img}) => {
        dispatch({
            height: img.naturalHeight||0,
            width: img.naturalWidth||0
        });
    };
    useEffect(  () => {
        onMeasure(state);
    },[state]);

    //TBD attach elsewhere ?...?portal // ?make this  a hook - see usecallback
    // todo ?failure
    return (
        <div style={{height:0,opacity:0, position:'relative'}}>
            {src && <img src={src} onLoad={onImgLoad} alt='measure' style={{position:'absolute'}}/>}
        </div>
    )
}
MeasureImg.prototype = {
    onMeasure: ()=>{}
};



// todo - ?wrapped components - good for defaults but mask IDE prop help for actual element
export function Pager(
    {
        style,
        pageSizeOptions = ['20','50','100'],
        ...props
    })
{
    //todo ? intercept currentPage & page size so we can use our new Page calc
    // - Pager just reduces current page if needed other wise keeps the saem
    // - I prefer adjusting the page to keep the view in about the same place
    return <Pagination
        style={{margin:5, ...style}}
        showSizeChanger={true}
        hideOnSinglePage={true}
        size="small"
        pageSizeOptions={pageSizeOptions}
        {...props}
    />
}

export function Label({colon=true, style, children,...props}){
    return <Typography.Text
        strong
        style={{height:24, ...style}}
    >{children}{colon && ": "}</Typography.Text>
}
// &nbsp = "\u00A0"

// ::before & ::after styles in .css for line thickness
export function DividerTitle({style, ...props}){
    return <Divider style={{borderTopColor: 'dimgray'}} className={'divider-title'}
                    orientation={'left'} {...props}/>;
}

export function PublicImage({path, alt='image',...props}){
    const {publicRoot} = useContext(ClientBridge);

    const src = (publicRoot || process.env.PUBLIC_URL ) + '/' +path;
    return <img src={src} alt={alt} {...props}/>
}


// Note this is a function rather than a component as DropDown overlay
// must be an antd <Menu> to style properly
export function getActionMenu({item, onAction, actions=[]}){
    return (
        <Menu>
            {actions.map( ({label,type,title})=>
                <Menu.Item
                    key={type}
                    icon={<AodIcon type={label||type}/>}
                    onClick={()=>onAction(item, type)}
                    title={title}
                >{label||type}</Menu.Item>
            )}
        </Menu>
    );
}

const downloadActions = [
    {type:'Download', label:'PDF', title:'High resolution'},
    {type:'Download JPEG', label:'JPEG'},
   {type:'Info View', label:'Production files', title: "View in Creative Library to access production files" },
    //{type:'Email Link', label:'Send production files', title: "Email production file link" },
    //{type:'View Link', label:'Production file link', title: "View production file link" }
];
export function getDownloadMenu(props){
    return getActionMenu({...props, actions:downloadActions})
}

const shareActions = [
    {type:'PDF'},
    {type:'Email'},
    {type:'Print'}
];
export function getShareMenu(props){
    return getActionMenu({...props, actions:shareActions})
}